import { gql } from '@zenbusiness/application-commons-graphql';

// Define query get list cards
export const GET_CARDS_QUERY = gql`
  query cards($listCardParams: CardInput!) {
    cards(params: $listCardParams) {
      cards {
        id
        type
        createdAt
        updatedAt
        last4Digits
        expirationDate
        status
        holder {
          firstName
          lastName
        }
        activatable
        address {
          postalCode
        }
      }
    }
  }
`;

// Define query get list card options
export const GET_CARD_OPTIONS_QUERY = gql`
  query cardsOptions($params: CardInput!) {
    cards(params: $params) {
      cards {
        id
        type
        last4Digits
        status
        updatedAt
      }
    }
  }
`;

export const GET_CARDS_PIN_STATUS_QUERY = gql`
  query cardPinStatus($params: CardPinStatusInput!) {
    cardPinStatus(params: $params)
  }
`;

export const GET_CARD_INFO = gql`
  query card($params: CardIdentifierInput!) {
    card(params: $params) {
      id
      type
      last4Digits
      dailyPinResetAttempts
    }
  }
`;
